// extracted by mini-css-extract-plugin
export default {"bar":"MobileBottomBar_bar__0uXBH","tab":"MobileBottomBar_tab__pdmBf","pill":"MobileBottomBar_pill__ISYIJ","on":"MobileBottomBar_on__t-50l","pip":"MobileBottomBar_pip__08gOw"};